export const cpds_partner_colors = {
    'cpds_partner_primary': '#1A2344',
    'cpds_partner_secondary': '#03D3F9',
    'cpds_partner_tertiary': '#1A2344',

    'cpds_partner_accent_800': '#02A8C6',
    'cpds_partner_accent_700': '#E9E9DE',
    'cpds_partner_accent_600': '#03D3F9',
    'cpds_partner_accent_500': '#03D3F9',
    'cpds_partner_accent_400': '#03D3F9',
    'cpds_partner_accent_300': '#03D3F9',
    'cpds_partner_accent_200': '#03D3F9',

    'cpds_partner_neutral_900': '#0C0E1C',
    'cpds_partner_neutral_800': '#191E3B',
    'cpds_partner_neutral_700': '#31374F',
    'cpds_partner_neutral_600': '#4d5167',
    'cpds_partner_neutral_500': '#676A7D',
    'cpds_partner_neutral_400': '#818494',
    'cpds_partner_neutral_300': '#999CAB',
    'cpds_partner_neutral_200': '#DFE0E4',
    'cpds_partner_neutral_100': '#F3F3F5',
    'cpds_partner_neutral_0': '#FFFFFF',    

    'cpds_partner_positive_900': '#022623',
    'cpds_partner_positive_600': '#227950',
    'cpds_partner_positive_500': '#57CA61',
    'cpds_partner_positive_300': '#57CA61',

    'cpds_partner_warning_900': '#420E1B',
    'cpds_partner_warning_700': '#A7183C',
    'cpds_partner_warning_400': '#F55669',
    'cpds_partner_warning_100': '#FED5D8',  
    
}

export const cpds_brand_colors = {
    'cpds_neutral_900': '#0C0E1C',
    'cpds_neutral_800': '#191E3B',
    'cpds_neutral_700': '#31374F',
    'cpds_neutral_600': '#4d5167',
    'cpds_neutral_500': '#676A7D',
    'cpds_neutral_400': '#9CA0B0',
    'cpds_neutral_300': '#D1D5E2',
    'cpds_neutral_200': '#E2E4EC',
    'cpds_neutral_100': '#F5F5F5',
    'cpds_neutral_0': '#FFFFFF',
    'cpds_red_900': '#330A05',
    'cpds_red_800': '#66130A',
    'cpds_red_700': '#991D10',
    'cpds_red_600': '#C01E1E',
    'cpds_red_500': '#E61E43',
    'cpds_red_400': '#ED4C67',
    'cpds_red_300': '#F37A8A',
    'cpds_red_200': '#EBB6B6',
    'cpds_red_100': '#FFE4E5',
    'cpds_orange_900': '#5A2201',
    'cpds_orange_800': '#B14402',
    'cpds_orange_700': '#D65A02',
    'cpds_orange_600': '#E04900',
    'cpds_orange_500': '#FA5100',
    'cpds_orange_400': '#FF7F3B',
    'cpds_orange_300': '#FFA580',
    'cpds_orange_200': '#FDCAAF',
    'cpds_orange_100': '#FAEFDE',
    'cpds_lemon_900': '#333205',
    'cpds_lemon_800': '#66650A',
    'cpds_lemon_700': '#99970F',
    'cpds_lemon_600': '#CBB918',
    'cpds_lemon_500': '#FDDB32',
    'cpds_lemon_400': '#FEE430',
    'cpds_lemon_300': '#FEED63',
    'cpds_lemon_200': '#FFF673',
    'cpds_lemon_100': '#FFFFA6',
    'cpds_cream_900': '#C0A569',
    'cpds_cream_800': '#C9B17C',
    'cpds_cream_700': '#D1BF97',
    'cpds_cream_600': '#DBCEB1',
    'cpds_cream_500': '#E4DAC4',
    'cpds_cream_400': '#EBE4D5',
    'cpds_cream_300': '#F0EBDF',
    'cpds_cream_200': '#F5F2EB',
    'cpds_cream_100': '#FBF8F1',
    'cpds_olive_900': '#263023',
    'cpds_olive_800': '#404A3A',
    'cpds_olive_700': '#5C6355',
    'cpds_olive_600': '#757D6D',
    'cpds_olive_500': '#8E9684',
    'cpds_olive_400': '#A7A797',
    'cpds_olive_300': '#BFBFAD',
    'cpds_olive_200': '#E1E5D0',
    'cpds_olive_100': '#F2F5E9',
    'cpds_green_900': '#001A07',
    'cpds_green_800': '#0C3D18',
    'cpds_green_700': '#175F29',
    'cpds_green_600': '#22823A',
    'cpds_green_500': '#2DA44A',
    'cpds_green_400': '#5CBA73',
    'cpds_green_300': '#8AD09B',
    'cpds_green_200': '#B8E6C3',
    'cpds_green_100': '#E6FCEB',
    'cpds_teal_900': '#134E45',
    'cpds_teal_800': '#526E6B',
    'cpds_teal_700': '#759C90',
    'cpds_teal_600': '#88B5A7',
    'cpds_teal_500': '#9BCEBE',
    'cpds_teal_400': '#5EEAD4',
    'cpds_teal_300': '#99F6E4',
    'cpds_teal_200': '#CCFBF1',
    'cpds_teal_100': '#F0FDFA',
    'cpds_blue_900': '#0E214B',
    'cpds_blue_800': '#112372',
    'cpds_blue_700': '#073198',
    'cpds_blue_600': '#0548BD',
    'cpds_blue_500': '#0076E5',
    'cpds_blue_400': '#008FF4',
    'cpds_blue_300': '#8BA5F5',
    'cpds_blue_200': '#56C6FB',
    'cpds_blue_100': '#ACE4FF',
    'cpds_white': '#FFFFFF',
    ...cpds_partner_colors
}

export const cpds_meso_colors = {
    //COMMON FOR EXPEDIA, HOTELS, VRBO
    'cpds_accent_800': '#0E3672',
    'cpds_accent_700': '#0D4EAF',
    'cpds_accent_600': '#1668E3',
    'cpds_accent_500': '#3D84F0',
    'cpds_accent_400': '#649DF2',
    'cpds_accent_300': '#80B2F4',
    'cpds_accent_200': '#ECF4FD',

    'cpds_accent_partner_900': '#02A8C6',
    'cpds_accent_partner_800': '#E9E9DE',
    'cpds_accent_partner_700': '#03D3F9',

    'cpds_neutral_900': '#0C0E1C',
    'cpds_neutral_800': '#191E3B',
    'cpds_neutral_700': '#31374F',
    'cpds_neutral_600': '#4d5167',
    'cpds_neutral_500': '#676A7D',
    'cpds_neutral_400': '#818494',
    'cpds_neutral_300': '#999CAB',
    'cpds_neutral_200': '#DFE0E4',
    'cpds_neutral_100': '#F3F3F5',
    'cpds_neutral_0': '#FFFFFF',    

    'cpds_positive_900': '#022623',
    'cpds_positive_600': '#227950',
    'cpds_positive_500': '#57CA61',
    'cpds_positive_300': '#57CA61',

    'cpds_warning_900': '#420E1B',
    'cpds_warning_700': '#A7183C',
    'cpds_warning_400': '#F55669',
    'cpds_warning_100': '#FED5D8',

    // Common Brand Colors 
    'cpds_lemon_500': '#FDDB32',    
    'cpds_lemon_600': '#CBB918',

    'cpds_green_200': '#B8E6C3',
    'cpds_green_600': '#22823A',
    'cpds_green_700': '#175F29',
    
    'cpds_red_500': '#E61E43',
    'cpds_red_400':'',
    'cpds_red_300':'',
    'cpds_red_200': '#EBB6B6',
    'cpds_red_100': '#FFE4E5',

    'cpds_cream_400': '#EBE4D5',
    'cpds_cream_100': '#FBF8F1',

    'cpds_blue_900': '#0E214B',
    'cpds_blue_300': '#8BA5F5',

    'cpds_orange_300': '#FFA580',
    
    'cpds_olive_400': '#A7A797',

    'cpds_teal_500': '#9BCEBE',
    ...cpds_partner_colors

}


